(() => {
  const tabLists = document.querySelectorAll('[data-lsc-tablist]');

  tabLists.forEach((list) => {
    const group = list.dataset.lscTablist;
    const tabs = Array.from(document.querySelectorAll(`[data-lsc-tab="${group}"]`))
      .filter((tab) => list.contains(tab));
    const enabledTabs = tabs.filter((tab) => tab.getAttribute('aria-disabled') !== 'true');
    if (!enabledTabs.length) return;

    const activate = (tab, moveFocus = false) => {
      if (!tab || tab.getAttribute('aria-disabled') === 'true') return;
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        const panel = document.getElementById(item.dataset.lscTarget);
        if (panel) panel.hidden = !selected;
      });
      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        if (tab.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        activate(tab);
      });

      tab.addEventListener('keydown', (event) => {
        const currentIndex = enabledTabs.indexOf(tab);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % enabledTabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + enabledTabs.length) % enabledTabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = enabledTabs.length - 1;
        else return;
        event.preventDefault();
        activate(enabledTabs[nextIndex], true);
      });
    });

    const initiallySelected = enabledTabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || enabledTabs[0];
    activate(initiallySelected);
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!reduceMotion.matches && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('[data-lsc-glass]').forEach((surface) => {
      surface.addEventListener('pointermove', (event) => {
        const bounds = surface.getBoundingClientRect();
        surface.style.setProperty('--lsc-case-x', `${event.clientX - bounds.left}px`);
        surface.style.setProperty('--lsc-case-y', `${event.clientY - bounds.top}px`);
      }, { passive: true });
      surface.addEventListener('pointerleave', () => {
        surface.style.removeProperty('--lsc-case-x');
        surface.style.removeProperty('--lsc-case-y');
      }, { passive: true });
    });
  }
})();
